<template>
  <el-dialog
    :title="matrix.id ? 'Редактирование матрицы талантов' : 'Создание матрицы талантов'"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="matrix"
      :rules="matrixRules"
      @submit.native.prevent="saveMatrix"
    >
      <el-form-item label="Название" prop="name">
        <el-input
          maxlength="1000"
          v-model="matrix.name"
          ref="matrixToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="description">
        <el-input
          maxlength="10000"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6}"
          v-model="matrix.description"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">Отмена</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveMatrix"
      > Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "talent-matrix-edit-dialog",
  data() {
    return {
      show: false,
      loading: false,
      matrix: {
        id: null,
        name: null,
        description: '',
      },
      matrixRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
      },
    }
  },
  methods: {
    async open(matrix) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.matrix = Object.assign({}, matrix);
      this.show = true;
      this.$nextTick(() => this.$refs.matrixToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveMatrix() {
      if (this.matrix.id) {
        this.updateMatrix();
      } else {
        this.createMatrix();
      }
    },
    createMatrix() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.talentMatrix.matrixCreate({
          name: this.matrix.name,
          description: this.matrix.description,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Матрица талантов успешно создана'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('matrix-saved');
          })
      })
    },
    updateMatrix() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.talentMatrix.matrixUpdate({
          id: this.matrix.id,
          name: this.matrix.name,
          description: this.matrix.description,
        })
          .then(data => {
            this.$notify.success({
              title: 'Обновлено',
              message: 'Матрица талантов успешно обновлена'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('matrix-saved');
          })
      })
    }
  }
}
</script>

<style scoped>

</style>